import styled from 'styled-components'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 16px;
`

export const Title = styled.div`
  font: normal normal bold 20px/24px Inter;
  color: ${props => props.theme.colors.color2d3139};
  text-align: center;
`

export const Details = styled.div`
  text-align: center;
  font: normal normal normal 14px/17px Inter;
  letter-spacing: 0px;
  color: ${props => props.theme.colors.color6b7786};
`

export const ImageContainer = styled.div`
  padding-bottom: 16px;
  display: flex;
  justify-content: center;
`
